export class SearchParams {
    searchText: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/common/entity/search-params.ts